var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.product.name
    ? _c("div", { staticClass: "sip-view-dl" }, [
        _c("div", { staticClass: "sip-view-dl__row" }, [
          _c("dt", [_vm._v("Product")]),
          _vm._v(" "),
          _c("dd", [_vm._v(_vm._s(_vm.product.name))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sip-view-dl__row" }, [
          _c("dt", [_vm._v("Current version")]),
          _vm._v(" "),
          _c("dd", [_vm._v(_vm._s(_vm.product.current_version))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sip-view-dl__row" }, [
          _c("dt", [_vm._v("Latest version")]),
          _vm._v(" "),
          _c(
            "dd",
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.product.latest_version) +
                  "\n                "
              ),
              _vm.product.current_version == _vm.product.latest_version
                ? _c(
                    "span",
                    {
                      staticClass:
                        "admin-status-badge admin-status-badge--success",
                    },
                    [_vm._v("Up to date")]
                  )
                : !_vm.update
                ? _c(
                    "router-link",
                    {
                      staticClass:
                        "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline mt-1",
                      attrs: { to: "/update" },
                    },
                    [_vm._v("Check updates")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.product.latest_version_release
          ? _c("div", { staticClass: "sip-view-dl__row" }, [
              _c("dt", [_vm._v("Release date")]),
              _vm._v(" "),
              _c("dd", [
                _vm._v(
                  _vm._s(_vm._f("moment")(_vm.product.latest_version_release))
                ),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }